import router from '@/router'
import store from '@/store'
import { isApp } from '@/utils/common'

const isMiniProgramWebView = () => {
  const ua = navigator.userAgent || ''
  return /AlipayClient|MicroMessenger/i.test(ua) && !/Html5Plus/i.test(ua)
}

const getUniBridge = () => {
  if (window.webUni) return window.webUni
  if (window.uni) return window.uni
  if (typeof uni !== 'undefined') return uni
  return null
}

const postAppMessage = (payload) => {
  const bridge = getUniBridge()
  if (bridge?.postMessage) {
    bridge.postMessage({ data: payload })
    return
  }
  console.warn('App 通信桥未就绪', payload)
}

const navigateMiniProgram = (url) => {
  const navigate = () => {
    if (window.wx?.miniProgram?.navigateTo) {
      window.wx.miniProgram.navigateTo({
        url,
        fail: (err) => console.warn('小程序跳转失败:', err)
      })
      return true
    }
    if (window.my?.navigateTo) {
      window.my.navigateTo({
        url,
        fail: (err) => console.warn('小程序跳转失败:', err)
      })
      return true
    }
    if (window.uni?.webView?.navigateTo) {
      window.uni.webView.navigateTo({ url })
      return true
    }
    if (window.uni?.navigateTo) {
      window.uni.navigateTo({ url })
      return true
    }
    return false
  }

  if (navigate()) return
  document.addEventListener('UniAppJSBridgeReady', navigate, { once: true })
  document.addEventListener('WeixinJSBridgeReady', navigate, { once: true })
  window.setTimeout(navigate, 300)
  window.setTimeout(() => {
    if (!navigate()) console.warn('小程序导航桥未就绪')
  }, 800)
}

const loginMiniProgram = () => {
  console.log('小程序登录')
  postMiniProgramMessage({
    action: 'znn_oneKeyLogin'
  })
  navigateMiniProgram('/pages/login/index')
}

const postMiniProgramMessage = (payload) => {
  const postMessage = () => {
    if (window.my?.postMessage) {
      console.log('支付宝小程序 postMessage', payload)
      window.my.postMessage({ data: payload })
      return true
    }
    if (window.wx?.miniProgram?.postMessage) {
      console.log('微信小程序 postMessage', payload)
      window.wx.miniProgram.postMessage({ data: payload })
      return true
    }
    if (window.uni?.webView?.postMessage) {
      console.log('uni webView postMessage', payload)
      window.uni.webView.postMessage({ data: payload })
      return true
    }
    return false
  }

  if (postMessage()) return
  document.addEventListener('UniAppJSBridgeReady', postMessage, { once: true })
  document.addEventListener('WeixinJSBridgeReady', postMessage, { once: true })
  window.setTimeout(postMessage, 300)
  window.setTimeout(() => {
    if (!postMessage()) console.warn('小程序消息桥未就绪', payload)
  }, 800)
}

const postNativeMessage = (payload) => {
  if (isMiniProgramWebView()) {
    postMiniProgramMessage(payload)
    return
  }
  postAppMessage(payload)
}

export default {
  appLogin: () => {
    if (isApp()) {
      console.log('app 环境')
      postAppMessage({
        action: 'znn_oneKeyLogin'
      })
    } else if (isMiniProgramWebView()) {
      console.log('isMiniProgramWebView 环境')
      loginMiniProgram()
    } else {
      router.push({ path: '/register' })
    }
  },
  appLogout: () => {
    window.app_menuList && window.app_menuList()
    // 退出后统一回到“我的”页，避免停留在业务深页
    store.commit('MENU_PATH', '/my')
    if (router.currentRoute.value?.name !== 'Main') {
      localStorage.setItem('componentName', '/my')
      router.replace({ name: 'Main' }).catch(() => {})
    }
    postAppMessage({
      action: 'znn_appLogout'
    })
  },
  appOtherWebView: (url) => {
    if (isApp()) {
      console.log('app 环境')
      postAppMessage({
        action: 'znn_otherWebView',
        data: { url }
      })
    } else {
      console.log('非app 环境')
      location.href = url
    }
  },
  appCloseWebView: () => {
    postAppMessage({
      action: 'znn_closeWebView'
    })
  },
  appCustomerService: (url) => {
    if (typeof window !== 'undefined' && window) {
      if (/iphone/gi.test(window.navigator.userAgent) && window.screen.height >= 812) {
        router.push({ path: '/iframe-view/webview', query: { title: '在线客服', url } })
        return
      }
    }
    postAppMessage({
      action: 'znn_otherWebView',
      data: { url }
    })
  },
  appGoBack: () => {
    postAppMessage({
      action: 'znn_goBack'
    })
  },
  appVersion: () => {
    postAppMessage({
      action: 'znn_appVersion'
    })
  },
  appSystemPermission: () => {
    postAppMessage({
      action: 'znn_systemPermission'
    })
  },
  appAction: (action) => {
    postAppMessage({
      action: 'znn_' + action
    })
  },
  // appGetPhoneInfo: () => {
  //   webUni.postMessage({
  //     data: {
  //       action: 'znn_getPhoneInfo'
  //     }
  //   })
  // },
  appSetNativeBackEnabled: (status) => {
    postAppMessage({
      action: 'znn_setNativeBackEnabled',
      data: {
        enabled: status
      }
    })
  },
  appGetLocationInfo: () => {
    postAppMessage({
      action: 'znn_getLocationInfo'
    })
  },
  appAlipayClient: (orderId, cashierId, returnUrl, extra = {}) => {
    postNativeMessage({
      action: 'znn_alipayClient',
      data: { orderStr: orderId, cashierId, returnUrl, ...extra }
    })
  },
  appWxPayClient: (orderId, cashierId) => {
    postAppMessage({
      action: 'znn_wxPayClient',
      data: { orderStr: orderId, cashierId }
    })
  },
  h5JumpPage: (path) => {
    console.log('path----', path)
    postAppMessage({
      action: 'znn_jumpPage',
      data: { path }
    })
  }
}
